'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var SelectableCard = require('../../../components/SelectableCard.js');
var styled = require('styled-components');
var VisuallyHidden = require('../../../components/VisuallyHidden.js');
var nthBitHeader = require('@narvar/nth-bit-header');
var index = require('../../../components/Icon/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const SelectableCardInner = styled__default["default"].div.withConfig({
  componentId: "sc-516k1g-0"
})(["display:flex;gap:1rem;"]);
const RadioContainer = styled__default["default"].div.withConfig({
  componentId: "sc-516k1g-1"
})(["flex-shrink:0;"]);
const Description = styled__default["default"].div.withConfig({
  componentId: "sc-516k1g-2"
})(_ref => {
  let {
    s
  } = _ref;
  return {
    marginTop: '0.25rem',
    ...s
  };
});
const ClaimSummaryAppeasementOption = _ref2 => {
  let {
    selected = false,
    name,
    value,
    onChange,
    title,
    description
  } = _ref2;
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  const [focused, setFocused] = React.useState(false);
  return /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: value
  }, /*#__PURE__*/React__default["default"].createElement(VisuallyHidden["default"], {
    id: value,
    as: "input",
    type: "radio",
    name: name,
    value: value,
    checked: selected ?? undefined,
    onFocus: () => setFocused(true),
    onBlur: () => setFocused(false),
    onChange: onChange
  }), /*#__PURE__*/React__default["default"].createElement(SelectableCard["default"], {
    selected: selected,
    focused: focused,
    as: "div"
  }, /*#__PURE__*/React__default["default"].createElement(SelectableCardInner, null, /*#__PURE__*/React__default["default"].createElement(RadioContainer, null, selected ? /*#__PURE__*/React__default["default"].createElement(index.IconThemed, {
    icon: "RadioSelected"
  }) : /*#__PURE__*/React__default["default"].createElement(index.IconThemed, {
    icon: "RadioUnselected"
  })), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "div"
  }, title), description && /*#__PURE__*/React__default["default"].createElement(Description, {
    s: bodytextDefaultNone
  }, description)))));
};
var ClaimSummaryAppeasementOption$1 = nthHookTheme.withThemeProvider(ClaimSummaryAppeasementOption, {
  themeTokens: ['bodytextDefaultNone']
});

exports["default"] = ClaimSummaryAppeasementOption$1;
